import { take, call, put, fork, all } from 'redux-saga/effects'
import fetchApi from '../../../../../utils/fetchApi'

function* getBrandListFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload: { filter }, next } = yield take('GET_SHOP_LOCATOR_LIST')

    try {
      const response = yield call(fetchApi, `ShopLocators?filter=${JSON.stringify(filter)}`)

      if (response && !response.error) {
        yield put({ type: 'GET_SHOP_LOCATOR_LIST_SUCCESS', payload: response })
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* getBrandListByStoreIdFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, next } = yield take('GET_SHOP_LOCATOR_LIST_BY_STORE_ID')

    try {
      const response = yield call(fetchApi, `ShopLocators/getBrandListByStoreId`, { storeId: payload.storeId })

      if (response && !response.error) {
        if (next && typeof next === 'function') {
          next(response)
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* addBrandFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, next } = yield take('ADD_SHOP_LOCATOR')

    const accountId = payload.accountId
    const data = {
      name: payload.name,
      location: payload.location,
      geometry: payload.geometry
    }

    try {
      const response = yield call(fetchApi, `Accounts/${accountId}/shopLocators`, data, { method: 'POST' })

      if (response && !response.error) {
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* editBrandFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, next } = yield take('EDIT_SHOP_LOCATOR')

    const brandId = payload.brandId
    const data = {
      name: payload.name,
      location: payload.location,
      geometry: payload.geometry
    }

    try {
      const response = yield call(fetchApi, `ShopLocators/${brandId}`, data, { method: 'PATCH' })

      if (response && !response.error) {
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* deleteBrandFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, next } = yield take('DELETE_SHOP_LOCATOR')

    try {
      const reqs = []
      payload.forEach((el) => {
        reqs.push(call(fetchApi, `ShopLocators/${el.id}`, {}, { method: 'DELETE' }))
      })

      const responses = yield all(reqs)
      if (responses && responses[0] && !responses[0].error) {
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

export default function* brandFlow() {
  yield fork(getBrandListFlow)
  yield fork(getBrandListByStoreIdFlow)
  yield fork(addBrandFlow)
  yield fork(editBrandFlow)
  yield fork(deleteBrandFlow)
}



// WEBPACK FOOTER //
// ./routes/app/routes/shop-locator/saga/index.js